import React from "react";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div
        className="custom-tooltip p-2 w-[83px] h-[58px] rounded-md"
        style={{
          background:
            "linear-gradient(178deg, #FFF 48.95%, rgba(255, 255, 255, 0.00) 98.03%)",
          boxShadow: "2px -3px 14.4px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        <div className="flex justify-between items-center">
          <img
            src={data.labelLink}
            alt="labelImage"
            className="w-7 h-7"
          />
          <div className="text-xs font-bold" style={{ color: data.color }}>
            {data.name}
          </div>
        </div>
        <div
          className="text-xs w-fit mx-auto font-normal mt-0.5"
          style={{ color: data.color }}
        >
          {data.labelValue}
        </div>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
